// 按页面划分
export default {
  // 公共页面
  common: {
    title:"Data Mall",
    pull_refresh: 'Pull down to refresh',
    release_refresh: 'Release to refresh',
    refresh_loading: 'Loading…',
    footer_text: 'Services provided by Ucloudlink (NASDAQ: UCL)'
  },
  home: {
    input_placeholder: 'Search country/region',
    my_flow: 'My data',
    charge_code: 'Voucher Code',
    coupons:'Coupons',
    local_package: 'Local Data',
    more: 'More',
    popular_destination: 'Country/region',
    buy_now:'Buy now',
    package_useing: 'Active',
    unused: 'Inactive',
    download_app: 'Download APP',
    enter_the_mall_list: 'Enter the mall list',
    no_data: 'No data',
    no_data_available: 'No data available',
    copy_success: 'Copied',
    copy_fail: 'Copy failed',
    meritsTitle: 'What Are the Advantages?',
    merits1: 'No SIM required & No Monthly Fee.',
    merits2: 'Integrated with top 2-3 operators for automatic network switching.',
    go_buy: 'Go to buy',
    instant_savings: 'Save',
    expires_in: 'Expires in',
    download_app_tips: "Download the App for More Offers & Experiences"
  },
  packages: {
    sub_title: {
      us: 'Excluding Guam, Saipan',
      it: 'Including Vatican City, San Marino',
      va: 'Including Italy, San Marino',
      sm: 'Including Italy, Vatican City',
      ma: 'Including Western Sahara',
      eh: 'Including Morocco',
      ch: 'Including Liechtenstein',
      li: 'Including Switzerland',
      fr: 'Including Monaco',
      mc: 'Including France',
      fi: 'Including Aland Islands',
      ax: 'Including Finland',
      gu: 'Including Northern Mariana Islands',
      mp: 'Including Guam'
    },
    unlimited_packages: 'Unlimited data package',
    normal_packages: 'Normal data package',
    multi_region_packages: 'Multi-region',
    regional_data: 'Regional Data',
    high_speed_text: 'high speed data',
    infiniteFlow:'Unlimited data',
    unLimitData: 'Unlimited',
    high_speed_text_year: 'high speed/mo',
    package_list: 'Package list',
    special_offer: 'Sale',
    first_month: '1st Mth',
    periodUnit: {
      day: 'day',
      month: 'month',
      hour: 'hour',
      year: 'year',
    },
    periodUnits: {
      day: 'day(s)',
      month: 'months',
      hour: 'hour(s)',
      year: 'years',
    },
    periodUnitSimp: {
      day: 'd',
      month: 'mo.',
      hour: 'h',
      year: 'yr'
    },
    periodUnitMonthly:'Monthly',
    periodUnitsSimp: {
      day: 'd',
      month: 'mos',
      hour: 'h',
      year: 'yr'
    },
    unlimited_good_name: {
      day: 'Day Pass',
      month: 'Monthly Pass',
      year: 'Yearly Pass'
    },
    continuousMonth : "Continuous months",
    continuousDay : "Continuous days",
    continuousYear:"Continuous years",
    day_invalid: 'Expire on the current day',
    month_invalid: 'Expire in the current month',
    immediate_valid: 'Effective immediately',
    tomorrow_day_valid: 'Effective from next day',
    tomorrow_month_valid: 'Effective from next month',

    // detail page
    detail: {
      cell_flow: 'Data',
      cell_period: 'Validity',
      buy_quantity: 'Amount',
      use_area: 'Coverage',
      use_intro: 'Terms and Conditions',
      buy_btn: 'Order',
      pay: 'Pay',
      buy_tips: 'You have the %@packageName package in use. Do you want to purchase this package?',
      haveOrderTips: "You have generated a pending payment order. Click Confirm to go to My Data Page for details!"
    },

    // confirm page
    confirm: {
      title: 'Confirm order',
      real_pay_amount: 'Amount paid',
      online_payment: 'Online Payment',
      create_order_error: 'Setup failed'
    }
  },

  pay: {
    // result page
    result: {
      loading_order_status: 'Getting order status…',
      buy_success: 'Order complete',
      buy_pending: 'Pending confirmation',
      buy_pending_tip: 'Payment in process…If payment didn\'t get transferred within 10 mins, please contact us for support.',
      get_payment_info_fail: 'Payment info acquisition failed',
      cell_package: 'Package',
      cell_buy_amount: 'Subtotal',
      cell_real_amount: 'Amount paid',
      go_to_order_btn: 'Go to My Package',
      back_home: 'Back to Home',
      back_mall: 'Back to mall',
      ordersn_empty: 'Order SN cannot be empty',
      order_search_error: 'Unexpected error',
      goodsName:"Product Name"
    },
    //fail page
    fail: {
      payment_fail: 'Payment failed',
      //payment_fail_desc: '请返回商品页面，重新购买',
      back_home: 'Back to Home'
    },
  },
  order: {
    state: {
      inUse: 'Activated',
      isFirst: 'Prioritized',
      toFirst: 'Set Priority',
    },
    periodUnits: {
      minute: 'minute(s)',
      hour: 'hour(s)',
      day: 'day(s)',
      month: 'month(s)',
    },
    useIntro: {
      tip1: 'Unlimited data package has higher priority than volume data package.',
      tip2: 'The usage priority will be based on purchase date for the same type of package,i.e., the package with the earliest purchase date will be used up first,while the priority of single-region packages is higher than regional package.',
      tip3: 'You can also manually adjust the priority of using packets of the same type.'
    },
    myFlow: 'My data',
    remainingFlow: 'Data left',
    remainingTime: 'Valid left',
    remainingHighFlow: 'High-speed data left',
    validPeriod: 'Validity',
    noneFlow: 'No data package',
    noneFlowTip: 'Please purchase the data package and enjoy the high quality network',
    buyPackFlow: 'Buy packages',
    checkInvalidFlow: 'Check expired data package',
    orderList: {
      title: 'My orders',
      amount_paid: 'Total',
      device: 'Owned device',
      order_details: 'Order details',
      total_amont: 'Subtotal',
      orderSN: 'Order no.',
      createTime: 'Creation time',
      cancelTime: 'Closed time',
      payTime: 'Order time',
      unsubTime: 'Canceled time',
      payMethod: 'Payment method',
      thirdSN: 'Transaction no.',
      delete: 'Delete',
      cancel: 'Cancel',
      unsub: 'Refund',
      goto_cancel: 'Do you want to cancel the order?',
      goto_unsubscribe: 'Do you want to unsubscribe the order?',
      delete_Tips: 'The order can not be resumed after being deleted, therefore your after-service problems can not be handled. Are you sure to delete it?',
      status_success: 'Completed',
      status_pending: 'Unpaid',
      status_cancel: 'Closed',
      status_unsub: 'Canceled',
      payMethod_stripe: "Credit Card"
    }
  },
  registerlogin: {
    create_account_tip:'Create an account, Start exclusive experience',
    select_country_tip:'Device Use Country/Region',
    email_name: "Mail",
    phone_name: "Phone",
    email_address: "Email address",
    password: "password",
    country: "country",
    select_country: "Choose a country",
    cancel: "Cancel",
    confirm: "Sure",
    please_enter: "Please enter 6-20 characters (combination of letters, numbers or symbols)",
    select_country_tips: "Country selection is for viewing local packages. It cannot be changed after registration. Please confirm!",
    global_roaming: "International domain code",
    phone_number: "phone number",
    agree: "agree",
    user_agreement: "User Agreement",
    and: "and",
    privacy_policy: "Privacy Policy",
    register_login: "Sign up or log in",
    login_error: "The number of logins is too frequent, please try again later!",
    register_error: "The number of registrations is too frequent, please try again later!",
    forgot_pwd: "forget the password",
    app_tips: "Log in to the app with this account after downloading it to access more features.",
    download_app: "Go to download the APP",
    rememberPwd: 'remember password',
    third_login: 'Continue with',
    agreement_tips: "Please check the User Agreement and Privacy Policy box",
    selectCountry_tips: "Please kindly note that the registered country will directly affect the following payment methods and currencies, please select according to your need.",
    login_error_cancel: "user cancelled the login",
    login_error_auth: "please allow popup from browser settings",
    device_tips: "Device pending activation. Thanks for your patience while we process this within 24 hours"
  },
  forgotPwd: {
    forgot_pwd: "forget the password",
    email_address: "Email address",
    next: "Next",
    email_has_been_sent: "We have sent an email to %@email. Please click on the link and follow the steps to retrieve your password.",
    have_retrieved_it: "I've found it",
    unable_to_receive_email: "Can't receive the email? Please check whether there are emails from %@email under your spam and deleted mail directory",
    or: "or",
    resend: "Resend",
    global_roaming: "International domain code",
    phone_number: "phone number",
    verification_code_has_been_sent: "We have sent the verification code to:",
    verification_code: "Verification code",
    no_verification_code_received: "Didn't receive the verification code?",
    please_enter: "Please enter 6-20 characters (combination of letters, numbers or symbols)",
    reset_password: "Reset password",
    reset_successful: "Reset successfully"
  },
  coupons: {
    coupons_name: "Coupons",
    no_coupons: "No coupons yet",
    no_data: "No data yet",
    applicable_to_the_following: "Coupons are suitable for the following data package"
  },
  digital: {
      title: "Device SN",
      purchased: "My Purchases",
      viewAll: "More",
      skinStore: "Product Store", 
      completed: "Purchased",
      goBuy: "Buy",
      order: {
          title: "Purchased Orders"
      },
      detail: {
          describe: "Description"
      }
  },
  viewPL: {
    other: 'others'
  },
  invalidFlow: {
    stateName: 'Status',
    state: {
      NOT_ACTIVATED: "Inactivated",
      IN_USING: "Available",
      USE_END: "Exhausted",
      EXPIRE: "Expired",
      TRANSFER: "Transfer",
      UNSUBSCRIBE: "Cancel",
      VALID: "Valid",
      INVALID: "Invalid",
      EXCHANGE_POINTS: "Redeem Points"
    },
    noneFlow: 'No expired data package',
    pageName: 'Expired data package'
  },
  CountryGroup: {
    title: "Country/region",
    placeholder: "Search country or region",
    clear: "Clear",
    history: "Search History"
  },
  PromotionCode: {
    verification: {
      title: 'Voucher Code',
      minititle:'Voucher Code',
      input: 'Please enter the top-up code',
      explain: 'Tips: Touch the scan button on the top right to scan the QR code of the voucher card, or manually input the voucher code (case sensitive) if it does not work.',
      submit: 'Submit',
      exchange: 'Redeem',
      cancel: 'Cancel',
      ErrorCode: 'Recharge Code Error',
      Inquiry: "Are you sure to exchange",
    },
    recharge_success: {
      package: 'Package',
      content: 'Successfully Redeemed',
      back: 'Back to Shopping Mall',
      view_packets: 'Go to My Package'
    }
  },
  flowDetail: {
    title: 'Data details',
    flow: 'Data',
    validTime: 'Data details',
    invalidTime: 'Valid until',
    coverage: 'Coverage',
    useIntro: 'Terms and Conditions',
    purchaseTime: 'Purchased at',
    subtotal: 'Subtotal',
    status: 'Status',
    cancel: 'Cancel',
    buyAgain: 'Buy it again',
    validity: 'Validity',
    tip: 'Notice',
    cancelTip: 'Are you sure you want to refund this package?',
    dataLeft: 'Data left'
  },
  netError: {
    try_again: 'Try again',
    net_error: 'No network',
    try_again_desc: 'Please check the network setting and try again'
  },
  loadFail: {
    try_again: 'Try again',
    load_fail: 'Loading failed',
    load_fail_desc: 'Data loading failed, please try again',
    IMEI_Not_Exist: 'IMEI Not Exist,Please try to enter from the right entrance',
    Project_Not_Exist:'An error occurs. Please contact customer service.(01)',
    commonError:'An error occurs. Please contact customer service.',
  },
  settlement_Easy_and_convenient:"Easy and convenient",
  settlement_Great_deal:"Great deal",
  settlement_Safe_and_secure:"Safe and secure",
  settlement_Autopay_service_regulation:"Autopay service regulation",
  settlement_Read:"Read",
  settlement_No_coupon:"No available coupon",
  settlement_Subtotal:"Subtotal",
  settlement_Coupon:"Coupon",
  settlement_TOTAL:"Total",
  settlement_promotion_tip:"The promotional offer cannot be used in conjunction with any coupons",
  settlement_coupon_tip:"The coupon cannot be used in conjunction with any other promotional offers",
  member_myFlow_noList:"No Data",
  detail_se_content:"A secure, easy and conveninet way. You can unsubscirbe at any time ",
  Enter_Promo_code:"Promotion code",
  Enter_Promo_Coupon:"Coupons",
  settlement_Not_used_coupon:"coupon not used",
  settlement_Available_coupon:"Available",
  settlement_Unavailable_coupon:"Unavailable",
  please_Enter_Promo_code:"Please enter the promotion code",
  please_Select_Coupon_use:　"Please select the coupon you want to use.",
  Buy_Now:"Buy Now",
  Dont_Use_Any:"Don't use any",
  settlement_confirm: "Confirm",
  flowDetail_unsubscribe: "Unsubscribe",
  flowDetail_unsubscribed: "Unsubscribed",
  flowDetail_isCancelPackage: "Unsubscribe this package?",
  flowDetail_confirmAgreementUnsubscribe : "You cannot have the great deal after unsubscribe. Are you sure you want to unsubscribe?",
  flowDetail_cancel: "Cancel",
  flowDetail_cancelSuccess: "Unsubscribe Successfully",
  packages_detail_promotion:"Promotion",
  orderTips:{
        "iDay" : "day",
        "iDays" : "days",
        "iMonth" : "month",
        "iMonths" : "months",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol on your first buy, pay %@money/%@periodSymbol later, You can unsubscribe at any time",
        'Monthly_discount':"Save %@saveMoney each %@period! You can unsubscirbe at any time ",
        'Ordinary_monthly_package':"A secure, easy and conveninet way. You can unsubscirbe at any time",
        "AlreadyPurchased":'Sorry that you can only subscribe to one data package at the moment. Please unsubscribe from “%@” and subscribe later to any package you desire after it expires.',
        "Contract_recommendation_First":'<label>With autopay service, on your first buy, pay only</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">You can unsubscribe at any time'
        +'<a class="btn">Subscribe ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>With autopay service, pay only</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">You can unsubscribe at any time'
        +'<a class="btn">Subscribe ></a></p>',
        "Contract_recommendation_General":"<label>With autopay service</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">A secure, easy and conveninet way. You can unsubscirbe at any time'
        +'<a href="javascript:;" class="btn">Subscribe ></a></p>',
        'BanlanceDoubleCheck':'Are you sure you want to pay with balance?',
    },
    feedback: {
      title: "feedback",
      placeholder: "Please enter the country you wish to visit or any other questions, and we will meet your needs as soon as possible!",
      submit: "Submit",
      submit_success: "Submitted successfully",
      other_opinions: "Other opinions",
    },
    view_country_input: 'Please enter your account',
    select_package: {
      "title": "Select Data",
      "allPackage":'All Data',
      "type": "Type",
      "flow": "Data",
      "month_package": "Monthly Plan",
      "flow_package": "Package",
      "time": "Duration",
      "period": "Cycle",
      "auto_debit": "Auto-Debit Info",
      "auto_subscribe": "Auto-Renew",
      "detail": "Data Details",
      "carrier": "Supported Carriers",
      "country": "Covered Countries List",
      "notice": "Purchase Guidelines"
    }
}